module.exports = __webpack_public_path__ + "static/img/3.28b7ac8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/4/eng/3.png
// module id = VpvZ
// module chunks = 0